module.exports = __webpack_public_path__ + "static/img/3.0.1ab89c03.png";